import { FC } from 'react';

import { Box } from '@mui/material';

import { TSelectOption } from 'shared/services/types/common.types';
import { FilterItemDate } from 'shared/ui/filter-item-date';
import { Input } from 'shared/ui/input';
import { SelectSearch } from 'shared/ui/select-multi';

interface IProps {
  accSorted: TSelectOption[];
  isAccountsLoading: boolean;
}

export const MethodFields: FC<IProps> = ({ accSorted, isAccountsLoading }) => {
  return (
    <>
      <Box sx={{ minWidth: '19%' }}>
        <Input name='remarks' label='Remarks' placeholder='Remarks' />
      </Box>
      <Box sx={{ minWidth: '19%' }}>
        <Input name='subagent_id' label='Sub ID' placeholder='Enter sub id' />
      </Box>
      <Box sx={{ minWidth: '19%' }}>
        <SelectSearch
          isMulti
          inputLabel='Account number'
          inputPlaceholder='Enter account number'
          name='accountNumber'
          options={accSorted}
          isOptionsLoading={isAccountsLoading}
        />
      </Box>
      <Box sx={{ minWidth: '19%' }}>
        <SelectSearch
          inputLabel='Status'
          inputPlaceholder='Select status'
          name='status'
          options={[
            { value: 'received', label: 'Pending' },
            { value: 'declined', label: 'Declined' },
            { value: 'done', label: 'Approved' }
          ]}
        />
      </Box>
      <Box sx={{ minWidth: '19%' }}>
        <FilterItemDate labelText='Date from - to' />
      </Box>
    </>
  );
};
